import React from 'react';
import ReportList from './ReportList';
import classes from './ReportPage.module.css';


const ReportTableContainer = ({
    createMode,
    selectedView,
    setCreateMode,
    setselectedReport,
    setSelectedView,
    ...props
}) => {

    return (
        <div className={classes.TableContainer}>
            <div  className={classes.GridContainer}>
                <ReportList
                    selectedView={selectedView}
                    setSelectedView={setSelectedView}
                    announcementCreate={createMode}
                    setCreateMode={setCreateMode} 
                    setselectedReport={setselectedReport}
                />
            </div>
        </div>
    );
};

export default ReportTableContainer;
